import React, { useEffect, useState } from "react";
import AppRoutes from "./routes/AppRoutes";
import { ApiLoaderProvider } from "./shared/context/ApiLoaderContext";
import { GlobalModalProvider } from "./shared/context/GlobalModalContext";
import { CHUNK_RELOAD_KEY } from "./shared/constants";
import { preloadSideMenu } from "./shared/hooks/useSideMenu";
import { msalInstance } from "./shared/services/msal/msalInstance";
import { SkeletonComponents } from "./components/ui/skeleton";

const App = (): React.ReactElement => {
  const [isAppInitialized, setIsAppInitialized] = useState(false);

  useEffect(() => {
    let isMounted = true;

    // App initialization: clear the reload guard before loading initial data
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);

    const initializeApp = async (): Promise<void> => {
      if (msalInstance.getActiveAccount()) {
        await preloadSideMenu();
      }

      if (isMounted) {
        setIsAppInitialized(true);
      }
    };

    void initializeApp();

    return (): void => {
      isMounted = false;
    };
  }, []);

  if (!isAppInitialized) {
    return <SkeletonComponents.layoutSkeleton />;
  }

  return (
    <>
      <ApiLoaderProvider>
        <GlobalModalProvider>
          <AppRoutes />
        </GlobalModalProvider>
      </ApiLoaderProvider>
    </>
  );
};

export default App;
